import { STAGE_3 } from 'constants/FarmboxConstants/stage3.constants';
import { FieldType } from 'enums/FieldTypeEnums';

const { SCOPE_1_AND_2_LABELS, FUEL_AND_ENERGY_FIELD_NAMES, HEADINGS } = STAGE_3;
const {
  FIELD_FARM_NAME,
  FIELD_FARM_ADDRESS,
  FIELD_FARM_SCOPE1,
  FIELD_FARM_SCOPE2,
  FIELD_REVENUE_PERCENTAGE,
  FIELD_TOTAL_EMISSION,
} = FUEL_AND_ENERGY_FIELD_NAMES;
const {
  GUTTER_VALUE,
  FARM_NAME,
  FARM_ADDRESS,
  FARM_SCOPE1,
  FARM_SCOPE2,
  FARM_ALLOCATION,
  TOTAL_EMISSION,
} = SCOPE_1_AND_2_LABELS;

const { LOCATION, COMMODITY } = HEADINGS;

const { INPUT } = FieldType;
export const getFuelAndEnergyFarmFormFields = () => {
  return {
    data: [
      {
        type: INPUT,
        fieldProps: {
          name: `${LOCATION}.${FIELD_FARM_NAME}`,
          label: FARM_NAME,
          disabled: true,
        },
        span: 5,
      },
      {
        type: INPUT,
        fieldProps: {
          name: `${LOCATION}.${FIELD_FARM_ADDRESS}`,
          label: FARM_ADDRESS,
          disabled: true,
        },
        span: 10,
      },
    ],
    rowGutter: GUTTER_VALUE,
  };
};

export const getFuelAndEnergyScopeFormFields = () => {
  return {
    data: [
      {
        type: INPUT,
        fieldProps: {
          name: `${COMMODITY}.${FIELD_FARM_SCOPE1}`,
          label: FARM_SCOPE1,
          disabled: true,
        },
        span: 5,
      },
      {
        type: INPUT,
        fieldProps: {
          name: `${COMMODITY}.${FIELD_FARM_SCOPE2}`,
          label: FARM_SCOPE2,
          disabled: true,
        },
        span: 5,
      },
      {
        type: INPUT,
        fieldProps: {
          name: `${COMMODITY}.${FIELD_REVENUE_PERCENTAGE}`,
          label: FARM_ALLOCATION,
          disabled: true,
        },
        span: 5,
      },
      {
        type: INPUT,
        fieldProps: {
          name: `${COMMODITY}.${FIELD_TOTAL_EMISSION}`,
          label: TOTAL_EMISSION,
          disabled: true,
        },
        span: 5,
      },
    ],
    rowGutter: GUTTER_VALUE,
  };
};
